// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "src/components/SoftBox";

// Soft UI Dashboard PRO React base styles
import colors from "src/assets/theme/base/colors";
import typography from "src/assets/theme/base/typography";
import borders from "src/assets/theme/base/borders";

function DataTableBodyCell({
  noBorder = false,
  align = "left",
  children,
  onClick,
}) {
  const { light } = colors;
  const { size } = typography;
  const { borderWidth } = borders;

  return (
    <SoftBox
      component="td"
      textAlign={align}
      fontSize={size.sm}
      borderBottom={noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`}
      py={1.5}
      px={1}
      onClick={
        children.props.cell?.value?.$$typeof === Symbol.for("react.element")
          ? null
          : () => (onClick ? onClick(children.props.row.original) : null)
      }
    >
      <SoftBox
        display="inline-block"
        width="100%"
        color="text"
        sx={{
          verticalAlign: "middle",
        }}
      >
        {children}
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  onClick: PropTypes.func,
};

export default DataTableBodyCell;
